<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">条款及条件</span></h2>
    <h4>
      <strong><span style="font-size: 12pt">基本规则</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">我们的网站仅限于达到个人居住司法管辖区规定的法定年龄的个人。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">我们的网站对任何用户使用我们网站所侵犯的任何国家法律、联邦法律或国际法律不承担任何责任。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">用户应对自己的行为负责，并受其所在国家法律（包括州法律或法律问题）的约束。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">所有代理商均对其各自会员的账户负责，并尊重其提交的所有已确认投注。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">代理商不是我们网站的合作伙伴。因此，我们的网站对玩家和经纪人之间的任何差异或争议不承担任何责任。
          </span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">用户有责任保护其用户名和密码免遭未经授权的使用。如果用户的用户名和密码被盗或泄露，用户有责任立即联系其代理人。然后，代理将为他/她更改用户的用户名和密码。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">如果用户名和密码被盗，用户对其各自的帐户负责，并将兑现所有提交的已确认投注。</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">游戏规则</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">我们网站决定的比赛结果将是最终的并具有约束力。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">在所有争议情况下，我们网站的管理人员和玩家都必须同意我们的网站交易日志数据库将作为争议的最终仲裁者。所有争议必须在比赛结果确定之日内提出。比赛日后，任何索赔均不予受理。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">玩家全权负责验证其所有帐户交易的准确性。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">在通过计算机提交投注之前，请务必检查您的投注是否有任何错误、错误或遗漏。一旦通过电脑接受投注，就无法更改或取消。
          </span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我们保留冻结或取消任何违反本条款和条件、参与欺诈活动、侵入、攻击、伪造、破坏标准规则或参与集团投注的客户账户的权利，所有由此产生的账户余额将被冻结和没收恕不另行通知。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我们保留作废或取消任何被发现涉及集团投注、协同投注、串通、欺诈、系统滥用、利用技术错误、错误赔率，或任何其他试图获取不公平优势的投注或注单的权利。任何相关赢款均可能被撤销，相关账户也可能被暂停或关闭。s</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">限制和责任</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">在不损害前述规定的一般性的情况下，如果发生破坏、不可抗力和/或我们网站中央计算机系统或记录或任何部分发生故障、损坏或毁坏，我们网站将不对任何人承担责任因任何电信或任何数据传输系统故障而导致的延迟、损失、错误、遗漏或任何其他情况，或导致未收到特定比赛的任何参赛作品的任何延迟。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我们的网站不会对因不可抗力、爆发敌对行动、骚乱、内乱、恐怖主义行为、政府或当局行为（包括拒绝或撤销任何许可或同意）、火灾爆炸、洪水、盗窃、恶意破坏、罢工、停工和任何形式的工业行动。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">如果因网络连接、通讯、系统或人为错误而导致投注相关问题，例如双倍投注被接受、投注无法确认、比赛开始后投注等。我们保留在此类情况下发生的权利错误，根据具体情况进行解决，并采取任何其他措施来纠正此类错误。我们不会就此类错误对您或任何第三方承担任何责任。如果您遇到此类错误并在未向上线报告的情况下继续投注，则如果错误再次发生，您将承担责任并尊重所有输赢结果。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">这些规则和条例构成双方之间的完整协议和谅解。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">如果本规则和条例的英文版本与任何其他语言版本之间存在任何差异，则以英文版本取代其他语言并被视为正确和有效。</span>
        </p>
      </li>
    </ol>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
